import { useTranslation } from "react-i18next";
import { Sheet, SheetContent, SheetHeader, SheetTitle } from "@/components/ui/sheet";
import { Input } from "@akuna/ui";
import { Label } from "@/components/ui/label";
import { Checkbox } from "@akuna/ui";
import { Switch } from "@akuna/ui";
import { Button } from "@akuna/ui";

export type FilterOption = { value: string; label: string };

type Props = {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  searchTerm: string;
  setSearchTerm: (v: string) => void;
  vetOptions: FilterOption[];
  selectedVets: string[];
  setSelectedVets: (v: string[]) => void;
  typeOptions: FilterOption[];
  selectedTypes: string[];
  setSelectedTypes: (v: string[]) => void;
  statusOptions: FilterOption[];
  selectedStatuses: string[];
  setSelectedStatuses: (v: string[]) => void;
  onlyTaxiDog: boolean;
  setOnlyTaxiDog: (v: boolean) => void;
  onClear: () => void;
};

function toggle(list: string[], value: string): string[] {
  return list.includes(value) ? list.filter((v) => v !== value) : [...list, value];
}

export function MobileCalendarFilterSheet(props: Props) {
  const { t } = useTranslation("calendar");
  const {
    open, onOpenChange, searchTerm, setSearchTerm,
    vetOptions, selectedVets, setSelectedVets,
    typeOptions, selectedTypes, setSelectedTypes,
    statusOptions, selectedStatuses, setSelectedStatuses,
    onlyTaxiDog, setOnlyTaxiDog, onClear,
  } = props;

  const renderGroup = (
    label: string, options: FilterOption[], selected: string[], setSelected: (v: string[]) => void,
  ) => (
    <div className="space-y-2">
      <Label className="text-sm font-semibold">{label}</Label>
      <div className="space-y-1.5">
        {options.map((opt) => (
          <label key={opt.value} className="flex items-center gap-2 text-sm">
            <Checkbox
              checked={selected.includes(opt.value)}
              onCheckedChange={() => setSelected(toggle(selected, opt.value))}
            />
            {opt.label}
          </label>
        ))}
      </div>
    </div>
  );

  return (
    <Sheet open={open} onOpenChange={onOpenChange}>
      <SheetContent side="bottom" className="max-h-[85vh] overflow-y-auto rounded-t-3xl">
        <SheetHeader className="text-left">
          <SheetTitle>{t("mobile.filters.title")}</SheetTitle>
        </SheetHeader>
        <div className="space-y-5 py-4">
          <div className="space-y-2">
            <Label htmlFor="agenda-search" className="text-sm font-semibold">{t("mobile.filters.search")}</Label>
            <Input
              id="agenda-search"
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
              placeholder={t("mobile.filters.searchPlaceholder")}
            />
          </div>
          {renderGroup(t("mobile.filters.professional"), vetOptions, selectedVets, setSelectedVets)}
          {renderGroup(t("mobile.filters.type"), typeOptions, selectedTypes, setSelectedTypes)}
          {renderGroup(t("mobile.filters.status"), statusOptions, selectedStatuses, setSelectedStatuses)}
          <label className="flex items-center justify-between text-sm font-semibold">
            {t("mobile.filters.taxiDog")}
            <Switch checked={onlyTaxiDog} onCheckedChange={setOnlyTaxiDog} />
          </label>
        </div>
        <div className="flex gap-2 pb-2">
          <Button variant="outline" className="flex-1" onClick={onClear}>{t("mobile.filters.clear")}</Button>
          <Button className="flex-1" onClick={() => onOpenChange(false)}>{t("mobile.filters.apply")}</Button>
        </div>
      </SheetContent>
    </Sheet>
  );
}
